/**
 * Extend the Window interface to include the `twitter` property.
 * @typedef {typeof globalThis & { twq?: (...args: any[]) => void }} CustomWindow
 */

/**
 * Send a Twitter Pixel event.
 * @param {string} id The pixel id.
 */
export async function twitterPixel(id) {
  const win = /** @type {CustomWindow} */ (window)
  if (typeof window !== 'undefined' && typeof win.twq === 'function') {
    win.twq('event', id, {})
  }
}
